import Row from '@quick/components/img/row.svg';
import clsx from 'clsx';
import { useCallback, useState } from 'react';

export interface IDetails {
  onChange?: (selected: boolean) => void;
  children: React.ReactNode;
  className?: string;
  title: string;
  isOpen?: boolean;
  hideTitle?: boolean;
}

export const Details = ({
  onChange,
  className,
  children,
  title,
  isOpen,
  hideTitle,
}: IDetails) => {
  const [open, setOpen] = useState(!!isOpen);
  const toggle = useCallback(() => {
    setOpen((open) => {
      onChange?.(!open);
      return !open;
    });
  }, [setOpen]);
  return (
    <div className={clsx('w-full flex-col', className)}>
      <button
        className="flex w-full items-center justify-between rounded border-2 border-gray-300 px-2
          py-1 dark:border-gray-700 dark:bg-gray-500 dark:text-white"
        onClick={toggle}
        title={title}
      >
        {!hideTitle && <span>{title}</span>}
        <Row
          height={16}
          className={clsx(
            '-rotate-90 transform transition-transform',
            open && 'rotate-0',
            hideTitle && 'mx-auto'
          )}
        />
      </button>
      {open && <div className="bg-transparent">{children}</div>}
    </div>
  );
};
